import React, { useRef, useState } from 'react';
import { isBrowser } from 'react-device-detect';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import { marginBottom } from 'styled-system';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '536px',
    height: 'auto',
    marginBottom: 6,
    minHeight: 74,
    paddingBottom: inputHeight => (inputHeight > 48 ? 26 : 0),
  },
  inSearcher: {
    maxWidth: '536px',
    minWidth: 'unset',
    height: 'auto',
    marginBottom: 6,
    '@media(max-width: 1250px)': {
      maxWidth: '100%',
    },
  },
  textField: {
    backgroundColor: 'white',
    margin: 0,
    padding: '0 0 24px 0',

    minWidth: '100%',
    marginRight: theme.spacing(1),
    '@media (max-width: 1250px)': {
      width: '100%',
      marginBottom: 6,
      maxWidth: 920,
    },
    '@media (max-width: 460px)': {
      minWidth: 'unset',
    },
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
}));

function debounce(fn, ms) {
  let timer;
  return _ => {
    clearTimeout(timer);
    timer = setTimeout(_ => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

function ComboText(props) {
  const {
    labelText,
    itemsCombo,
    setFieldValue,
    widthField,
    valuesMul,
    multiple,
    value,
    handleBlur,
    handleChanges,
    handleChange,
    textFieldStyles,
    sizeField,
    name,
    touched,
    errors,
    cierre,
    typeSelect,
    inSearcher,
    textFieldRoot,
    defaultValue,
    variant,
  } = props;
  // let sizeField = widthField ? widthField : '100%';
  const multiselect = useRef();
  const [inputHeight, setInputHeight] = useState(0);
  //const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  let classes = useStyles(inputHeight);

  React.useEffect(() => {
    setInputHeight(multiselect.current.parentElement.clientHeight);
    
    if(isBrowser){
      const debouncedHandleResize = debounce(function handleResize() {
        //setWindowWidth(window.innerWidth);
        setInputHeight(multiselect.current.parentElement.clientHeight);
      }, 1000);
  
      window.addEventListener('resize', debouncedHandleResize);
  
      return _ => {
        window.removeEventListener('resize', debouncedHandleResize);
      };
    }

  }, [valuesMul]);

  return (
    <>
      <Autocomplete
        getOptionLabel={option => option}
        multiple={multiple}
        value={valuesMul ? valuesMul : typeSelect}
        id={name}
        name={name}
        options={itemsCombo}
        filterSelectedOptions
        disableCloseOnSelect={cierre}
        onChange={(event, value) => {

          handleChanges(value);
        }}
        defaultValue={defaultValue}
        size={'small'}
        onBlur={handleBlur}
        className={sizeField ? sizeField : null}
        renderInput={params => (
          <TextField
            classes={{
              root: inSearcher ? classes.inSearcher :
              textFieldRoot ? textFieldRoot :
              classes.root
            }}
            helperText={touched && errors ? errors : ''}
            className={textFieldStyles ? textFieldStyles : null}
            error={touched && errors ? true : false}
            {...params}
            label={labelText}
            variant={variant ? variant : "outlined"}
            inputRef={multiselect}
          />
        )}
      />
    </>
  );
}

export default ComboText;




